import {v4 as uuid} from "uuid"
import styles from "./styles.module.css"
import FileThumb from "./FileThumb"

export default function FileUpload({files, setFiles}) {
  const onFileSelect = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onload = () => {
        setFiles([...files, {
          uuid: uuid(),
          name: file.name,
          content: reader.result,
          mimeType: file.type,
        }])
      }

      reader.readAsDataURL(file)
    }
  }

  return (
    <div className={"flex flex-wrap"}>
      {files.map((file) => (
        <FileThumb key={file.uuid} file={file}/>
      ))}

      <label className={styles.fileUploadButton} title={"Přidat přílohu"}>
        <i className={"fas fa-camera fa-xl"}/>
        <input type={"file"} onChange={onFileSelect} className={"hidden"}/>
      </label>
    </div>
  )
}
